<script lang="ts">
	import type { Snippet } from "svelte";
	import UserRoundIcon from "@lucide/svelte/icons/user-round";

	let {
		displayName = "Team Member",
		title = "Title",
		headshot = null,
		bio = null,
		label = "Leadership",
		children
	}: {
		displayName?: string;
		title?: string;
		headshot?: string | null;
		bio?: string | null;
		label?: string;
		children?: Snippet;
	} = $props();
</script>

<div class="bg-card border-border/50 rounded-2xl border p-8 shadow-md md:p-10">
	<div class="flex flex-col items-center gap-8 md:flex-row md:items-start">
		<div class="shrink-0">
			{#if headshot}
				<img
					class="ring-primary/40 h-40 w-40 rounded-full object-cover ring-4"
					src={headshot}
					alt={displayName}
					width="160"
					height="160"
					loading="lazy"
				/>
			{:else}
				<div
					class="ring-primary/40 bg-accent flex h-40 w-40 items-center justify-center rounded-full ring-4"
				>
					<UserRoundIcon class="text-muted-foreground h-12 w-12" />
				</div>
			{/if}
		</div>
		<div class="text-center md:text-left">
			<p class="text-primary text-sm font-semibold">{label}</p>
			<h3 class="text-foreground mt-1 text-2xl font-semibold tracking-tight">
				{displayName}
			</h3>
			<p class="text-muted-foreground mt-1">{title}</p>
			{#if children}
				<div class="mt-4">
					{@render children()}
				</div>
			{:else if bio}
				<p class="text-muted-foreground mt-4 leading-relaxed text-pretty">{bio}</p>
			{/if}
		</div>
	</div>
</div>
